import { Injectable } from '@angular/core';
import {HttpClient}from '@angular/common/http';
import { Observable } from 'rxjs';
import{Ba1110Class}from '../../Class/ba1110/ba1110-class'
import{Ba4010Class}from '../../Class/ba4010/ba4010-class'
import {environment} from '../../../environments/environment'
import { ADM0009Class } from '../../Class/ADM0009/adm0009-class';

@Injectable({
  providedIn: 'root'
})
export class ADM0009ServiceService {

  baseUrl: string=environment.baseUrl + 'ADM009/';
  constructor(private http:HttpClient) { }

LoadFind():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'LoadFind');
}
/////////////////
LoadGreetings():Observable<any>
{

  return this.http.get<any>(this.baseUrl+'LoadGreetings');
}
LoadDetailDocument(objADM0009Class:ADM0009Class):Observable<any>
{

  return this.http.post<any>(this.baseUrl+'LoadDetailDocument',objADM0009Class);
}
sendMessage(payload: any): Observable<any> {
  return this.http.post<any>(this.baseUrl + 'SendMessage', payload);
}
getUnread():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'getUnread');
}
loadMessages(payload: any): Observable<any> {
  return this.http.post<any>(this.baseUrl + 'LoadMessages', payload);
}
deleteMessage(payload: any): Observable<any> {
  return this.http.post<any>(this.baseUrl + 'deleteMessage', payload);
}
GetApprovalTimeline(payload: any): Observable<any> {
  return this.http.post<any>(this.baseUrl + 'GetApprovalTimeline', payload);
}
UserPermission(objADM0009Class:ADM0009Class):Observable<any>
{
   return this.http.post<any>(this.baseUrl+'UserPermission',objADM0009Class);
}
}